"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var canSetMuteOnEntry = function canSetMuteOnEntry(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.ENABLE_MUTE_ON_ENTRY);
};
var canSetDisallowUnmute = function canSetDisallowUnmute(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.ENABLE_HARD_MUTE);
};
var canUnsetMuteOnEntry = function canUnsetMuteOnEntry(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_MUTE_ON_ENTRY);
};
var canUnsetDisallowUnmute = function canUnsetDisallowUnmute(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_HARD_MUTE);
};
var _default = {
  canSetMuteOnEntry: canSetMuteOnEntry,
  canSetDisallowUnmute: canSetDisallowUnmute,
  canUnsetMuteOnEntry: canUnsetMuteOnEntry,
  canUnsetDisallowUnmute: canUnsetDisallowUnmute
};
exports.default = _default;
//# sourceMappingURL=util.js.map
